<template>
  <div style="margin-top:80px;" class="container-fluid">

       <div class="card">
        <div class="card-header  bg-info">
            <h4 class="header"><strong>STOCK CONSEGNATO -  LISTA DOCUMENTI</strong></h4>
             <small id="Help" class="form-text text-muted"></small>
        </div>
        
      <div class="card-body">
     
      <div class="table-wrapper-scroll-y my-custom-scrollbar">
      <table class="table table-hover  table-striped  table-sm mb-0" id="table">
        
      <thead>
        <tr>

          <th>#</th>
          
          <th>FORNITORE</th>

          <th>TIPO</th>
          <th>NUMERO</th>
          <th>DATA</th>
          <th>SEDE</th>
          <th>CREATO IL</th>
          <th>STAMPA ETICHETTE (jsPM)</th>
          <th>STAMPA ETICHETTE (Zebra)</th>
              
        </tr>
      </thead>
      <tbody>
      <tr @dblclick="openDocument(item)" class="pointer" v-for="(item,index) in filteredDocuments" :key="index">
        <td>{{index+1}}</td>

        <td>{{item.supplier}}</td>
        
        <td>{{item.description}}</td>
        <td>{{item.number}}</td>
        <td>{{item.date}}</td>
        <td>{{item.store}}</td>
        <td>{{item.create_at}}</td>
        <td><i @click="printModal(item,'EPL')" data-toggle="tooltip" title="stampa etichette EPL"  class="fa fa-print" aria-hidden="true">
          <span v-if="btn1 && spinner"  class="spinner-border spinner-border-sm ml-2"  role="status" aria-hidden="true"></span>
          </i></td>
        <td><i class="fa fa-print"
          @click="printModal(item,'ZPL')" data-toggle="tooltip" title="stampa etichette ZPL"   aria-hidden="true">
          <span v-if="btn2 && spinner"  class="spinner-border spinner-border-sm ml-2"  role="status" aria-hidden="true"></span>
          </i></td>
      </tr>
      </tbody>
      <tfoot>
        <tr>                  
        </tr>
      </tfoot>  
    </table>
  </div>

  
        
  <div class="form-group mt-5">
  <label for="cerca"><strong>Filtra</strong></label>
  <input id="cerca" class="form-control" type="text" name="query" v-model="filterKey">
  </div>
  

  </div>
  </div>

  <div v-if="movementId>0">
    
    <print-epl-modal :key="refreshEPL" v-bind:data='data'></print-epl-modal>
    <printZebraModal :key="refreshZPL" v-bind:data='data'></printZebraModal>  
  </div>
  

  </div>
</template>

<script>
import { mapGetters } from 'vuex';


import api                     from '@/api'

import printZebraModal           from '@/components/common/PrintZebraModal.vue';
import printEplModal             from '@/components/common/PrintJSPMModal.vue';
  export default {

     components: {printZebraModal,printEplModal},
     //props : ['storeId'],
    data () {
      return {
        
        items         : [],
        filterKey     : '',
        spinner       : false,
        movementId    : 0,
        data          : [],
        refreshEPL    : 0,
        refreshZPL    : 100,
      
        btn1          : false,
        btn2          : false 
        
       
        
        
      }
    },
    watch :
    {

    },
    
  
    computed: {
   
       ...mapGetters(['storeId']),
       filteredDocuments : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     
  
      
    },

    created () 
    {       
      this.getDocuments()
    },
    methods: 
    {

      getData() 
      {
      

        var data  = {'movementId' : this.movementId}
        var sp    = {'sp':'spStockMovementBarcodes'}
        var json  = Object.assign(data, sp)
        return new  Promise( async (resolve, reject)  =>  {
        
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
               resolve(res.data.recordsets[0])   
            }
           else if(res.status == 500)
           {
                console.log(res.data)                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          //this.spinner = false
        });          
        
        })

      }, 
    



      async printModal(item,lang)
      {
        this.spinner = true  
        this.btn1  = lang == 'EPL' ? true : false
        this.btn2  = lang == 'ZPL' ? true : false
        this.movementId = item.movementId
        this.data = await this.getData()
        this.spinner = false
        
        if(lang=='EPL')
        {
          this.refreshEPL++
          this.$nextTick(() => {
            $('#printEPLModal').modal({keyboard: false,backdrop:'static','show':true});
            })
        }
        else
        {
          this.refreshZPL++
          this.$nextTick(() => {
           $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
            
        })  
        }
        
      },

      
      
      openDocument(item)
      {
        return  
        this.$emit('update',item)
      },

      async getDocuments()
      {
        
        this.spinner = true
        var data  = {'storeId' : this.storeId}
        var sp    = {'sp'         : 'spStoreDocuments'}
        var json  = Object.assign(data, sp);

        await api.post(json).then(res => {
          
          if(res.status==200)
            {
             this.items = res.data.recordsets[0] 
            }
           else if(res.status==500)
           {
                console.log(res.data)                             
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          
          }).catch(err => {
              
              console.log(err.message)    
              
          }).finally(() => {
          this.spinner = false
        });



      },
      
      

    }
  }
</script>

<style scoped>
  
.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}

.my-custom-scrollbar {
    position  : relative;
    height    : 350px;
    overflow  : auto;
    }
.table-wrapper-scroll-y {
    display   : block;
  }
p,h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
   }
.header {
  font-family : 'Roboto Condensed';
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #E8A317;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .fa-print:hover{

    color : red;
}
 .fa-print{

     color       : brown;

 }
 .card-header
{
  height: 45px;
}
</style>
